import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProgressbarType } from 'ngx-bootstrap/progressbar';
import {
  FileSystemDirectoryEntry,
  FileSystemFileEntry,
  NgxFileDropEntry,
} from 'ngx-file-drop';

import { FileClass } from '../aws-s3-upload/file.class';

// interfaces
import {
  FolderListClass,
  IFileItem,
  IFolderItem,
  IFolderList,
  IS3Data,
} from '../aws-s3-upload/multipart.interface';
// import { DexieUploadService } from '../ngx-dexie/dexie-upload.service';
import { LocalForageService } from '../localforage.service';
import { AwsS3UploadServiceDrive } from './aws-s3-upload.service';

@Component({
  selector: 'mango-aws-s3-upload-drive',
  templateUrl: './aws-s3-upload.component.html',
  styleUrls: ['./aws-s3-upload.component.scss'],
})
export class AwsS3UploadComponentDrive implements OnInit {
  @Input() method!: string; // sdk || presigned
  @Input() bucket!: string; // bucket
  @Input() folder!: string; // folder key in bucket
  @Input() accessKeyId!: string; // access key to aws s3
  @Input() secretAccessKey!: string; // secret access key to aws s3
  @Input() region!: string; // region to aws s3

  @Input() compress!: boolean; // compress the smaller files to have less concurrent uploads
  @Input() filterTypes: string[] = ['image']; // compress the smaller files to have less concurrent uploads

  @Input() showMoreLimit!: number; // show more option (infinite scroll)
  @Input() useLocalDb: boolean = false; // show more option (infinite scroll)

  @Input() payloadToDB: any; // payload to insert into db

  @Output() uploaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() uploading: EventEmitter<any> = new EventEmitter<any>();

  token: string = this.generateToken();
  limitSize = 1048576; // size < 1MB

  isCompressing: boolean = false;
  hasCompressed: boolean = false;
  acceptedFilesType: string[] = [];

  selectedListView: string = 'list'; // grid / list
  showUploader: boolean = false;

  // -----

  files: NgxFileDropEntry[] = [];
  private listFilesFolder: IFolderList[] = [];
  listFilesFolderUI: IFolderList[] = [];

  private listSingleFiles: IFileItem[] = [];
  private listSingleFilesToCompress: IFileItem[] = [];
  listSingleFilesUI: IFileItem[] = [];
  listSingleFilesPaginateUI: IFileItem[] = [];
  listSingleFilesCompressedUI: IFileItem[] = [];
  page: number = 0;

  dataS3: IS3Data | undefined;

  completed: number = 0;
  pending: number = 0;
  total: number = 0;
  stacked = [
    {
      value: 1,
      type: 'success',
      label: '',
    },
    // {
    //   value: 20,
    //   type: 'info',
    //   label: ''
    // },
    // {
    //   value: 10,
    //   type: 'warning',
    //   label: ''
    // },
    {
      value: 100,
      type: 'secondary',
      label: '',
    },
    {
      value: 0,
      type: 'danger',
      label: '',
    },
  ];

  uploadedProgressLog: string[] = [];

  constructor(
    private awsS3UploadService: AwsS3UploadServiceDrive,
    private localForageService: LocalForageService
  ) {}

  ngOnInit() {
    this.dataS3 = {
      bucket: this.bucket,
      folder: this.folder,
      accessKeyId: this.accessKeyId || '',
      secretAccessKey: this.secretAccessKey || '',
      region: this.region || 'us-east-1',
    };

    // local forage service

    this.localForageService.init();

    // dexie - IndexedDB

    // if (this.useLocalDb) {
    //   const allDataDB = this.dexieUploadService.getAll();
    //   allDataDB.then(res => {
    //     // this.listFilesFolderUI = res;
    //     // this.files = this.listFilesFolderUI[0].files;
    //   });
    // }

    // uploader events

    this.awsS3UploadService.uploadProgress$.subscribe((event) => {
      if (event.payload) {
        const payload = event.payload;

        if (payload.type === 'folder') {
          const folderIndex = this.listFilesFolderUI.findIndex(
            (item) => item.token === payload.folderToken
          );
          const fileIndex = this.listFilesFolderUI[folderIndex].files.findIndex(
            (item) => item.token === payload.fileToken
          );

          const fileProgress =
            this.listFilesFolderUI[folderIndex].files[fileIndex].progress || 0;

          this.listFilesFolderUI[folderIndex].files[fileIndex].progress =
            event.progress >= fileProgress ? event.progress : fileProgress;
          const files = this.listFilesFolderUI[folderIndex].files.filter(
            (item) => item.status === 1
          );
          const partsTotal = files
            .map((item) => item.progress || 0)
            .reduce((a, b) => a + b);

          const folderProgress =
            (partsTotal * 100) /
            (this.listFilesFolderUI[folderIndex].files.filter(
              (item) => item.status === 1
            ).length *
              100);
          const currentProgress =
            this.listFilesFolderUI[folderIndex].progress || 0;
          this.listFilesFolderUI[folderIndex].progress =
            folderProgress > currentProgress ? folderProgress : currentProgress;
          this.listFilesFolderUI[folderIndex].files.forEach(
            (fileIntoFolder, key) => {
              if (fileIntoFolder.status === 0) {
                this.listFilesFolderUI[folderIndex].files[key].progress =
                  this.listFilesFolderUI[folderIndex].progress;
              }
            }
          );
        }

        if (payload.type === 'single file') {
          const fileIndex = this.listSingleFilesUI.findIndex(
            (item) => item.token === event.token
          );
          const fileProgress = this.listSingleFilesUI[fileIndex].progress || 0;
          this.listSingleFilesUI[fileIndex].progress =
            event.progress > fileProgress ? event.progress : fileProgress;
          if (this.listSingleFilesUI[fileIndex].type === 'mng-compressed') {
            const files =
              this.listSingleFilesUI[fileIndex].compressedFiles || [];
            files.forEach((item, i) => {
              this.listSingleFilesUI.forEach((part, key) => {
                if (this.listSingleFilesUI[key].file.name === item.name)
                  this.listSingleFilesUI[key].progress =
                    this.listSingleFilesUI[fileIndex].progress;
              }, this.listSingleFilesUI);
            });
          }
        }
      }
    });

    this.awsS3UploadService.finishedProgress$.subscribe((event) => {
      if (event.data) {
        if (this.pending !== 0) {
          this.completed++;
          this.pending--;
        }

        if (this.pending === 0) {
          this.getReallyUploadedFiles();
        }

        // this.stacked[0].value = this.completed;
        // this.stacked[1].value = this.pending;
        this.progressPercent(this.completed, this.pending);
      }
    });
  }

  progressPercent(
    successValue: number,
    pendingValue: number,
    dangerValue?: number
  ) {
    this.stacked[0].value = (successValue * 100) / this.total;
    this.stacked[1].value = (pendingValue * 100) / this.total;
  }

  // -- ngx-file-drop ----

  /**
   * Dropped files or folders.
   *
   * @param files
   */
  dropped(files: NgxFileDropEntry[]) {
    this.files = [...this.files, ...files];

    // if (files.length > 200) {
    //   this.method = 'presigned';
    // }

    let total = files.length;
    let counter = 0;
    for (let i = 0; i < files.length; i++) {
      const droppedFile = files[i];

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file(async (file: File) => {
          if (await this.filterType(file)) {
            counter++;
            this.uploading.emit(true);
            this.rebuildFoldersToUpload(droppedFile, file);
          } else {
            total--;
          }

          // finish for loop
          if (counter === total) {
            if (!this.listFilesFolder.length && !this.listSingleFiles.length) {
              this.files = [];
              this.acceptedFilesType = this.filterTypes;
              setTimeout(() => {
                this.acceptedFilesType = [];
              }, 5000);
            }

            if (!!this.compress) {
              this.refactorFilesToUpload();
            }
            this.listFilesFolderUI = this.listFilesFolder;
            this.listSingleFilesUI = this.listSingleFiles;

            // this.listSingleFilesPaginateUI = this.showMoreLimit ? this.paginate(this.listSingleFilesUI, this.showMoreLimit) : this.listSingleFilesUI;
            this.listSingleFilesPaginateUI = this.listSingleFilesUI;
            this.upload();

            // this.dexieUploadService.addOneFile(this.listFilesFolderUI[0]);
          }
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }

  /**
   * Detect files smaller than 1MB and prepare them in the compress list for uploading as .zip
   */
  async refactorFilesToUpload() {
    for (let i = 0; i < this.listFilesFolder.length; i++) {
      const item = this.listFilesFolder[i];
      if (item.type === 'folder') {
        for (let j = 0; j < item.files.length; j++) {
          const folderItem: IFolderItem = item.files[j];
          if (folderItem.file.size < this.limitSize) {
            // size < 1MB
            this.setIsCompressing(true);
            this.listFilesFolder[i].compress.push(folderItem);
            this.listFilesFolder[i].files[j].status = 0;
          }
        }

        // detect one file larger than 1MB
        item.files.findIndex((item) => item.status === 1) !== -1
          ? (this.listFilesFolder[i].oneValidFile = true)
          : (this.listFilesFolder[i].oneValidFile = false);

        if (this.listFilesFolder[i].compress.length) {
          const zipList: any[] = await this.compressFolderFiles(
            item.compress,
            item.name
          );
          this.setIsCompressing(false);
          zipList.forEach((zipFile) => {
            this.listFilesFolder[i].files.push({
              name: zipFile.zip.name,
              relativePath: item.files[0].relativePath,
              file: zipFile.zip,
              status: 1,
              // token: this.generateToken(),
              token: this.listFilesFolder[i].token,
              type: 'mng-compressed',
              compressedFiles: zipFile.files,
            });

            this.uploadProcess(zipFile.zip, this.listFilesFolder[i].token, {
              type: 'folder',
              folderToken: this.listFilesFolder[i].token,
              fileToken: this.listFilesFolder[i].token,
            });
            this.pending++;
          });
        }
      }
    }

    for (let i = 0; i < this.listSingleFiles.length; i++) {
      const fileItem: IFileItem = this.listSingleFiles[i];
      if (fileItem.file.size < this.limitSize) {
        // size < 1MB
        this.setIsCompressing(true);
        this.listSingleFilesToCompress.push(fileItem);
        this.listSingleFiles[i].status = 0;
      }
    }

    if (this.listSingleFilesToCompress.length) {
      const zipList: any[] = await this.compressSingleFiles(
        this.listSingleFilesToCompress,
        'single_files'
      );
      this.setIsCompressing(false);
      zipList.forEach((zipFile) => {
        const token = this.generateToken();
        this.listSingleFiles.push({
          relativePath: '',
          file: zipFile.zip,
          status: 1,
          token: token,
          type: 'mng-compressed',
          compressedFiles: zipFile.files,
        });

        this.uploadProcess(zipFile.zip, token, {
          type: 'single file',
          folderToken: token,
        });
        this.pending++;
      });
    }
  }

  /**
   * Browse all IFileItem type items and return them grouped and compacted in zip files.
   *
   * @param fileItems
   * @param name
   */
  async compressSingleFiles(fileItems: IFileItem[], name: string) {
    let filesToCompress: any[] = [];
    fileItems.forEach((fileItem: IFileItem) => {
      filesToCompress.push(fileItem.file);
    });

    return await this.awsS3UploadService.processZipList(filesToCompress, name);
  }

  /**
   * Browse all IFolderItem type items and return them grouped and compacted in zip files.
   *
   * @param folderItems
   * @param name
   */
  async compressFolderFiles(folderItems: IFolderItem[], name?: string) {
    let filesToCompress: any[] = [];
    folderItems.forEach((folderItem: IFolderItem) => {
      filesToCompress.push(folderItem.file);
    });

    return await this.awsS3UploadService.processZipList(
      filesToCompress,
      name || ''
    );
  }

  /**
   * Given the elements dragged in the drop in in build the structure with which to work these files.
   *
   * @param droppedFile
   * @param file
   */
  rebuildFoldersToUpload(droppedFile: any, file: File) {
    if (this.isFileInFolder(droppedFile)) {
      this.pushFileInFolder(droppedFile, file);
    } else {
      this.pushSingleFile(droppedFile, file);
    }
  }

  /**
   * Assemble the structure in case folders have been dragged.
   *
   * @param droppedFile
   * @param file
   */
  pushFileInFolder(droppedFile: any, file: File) {
    const folder = this.awsS3UploadService.getNameFirstFolder(droppedFile);
    const realName =
      this.awsS3UploadService.getRealNameFirstFolder(droppedFile);
    const position = this.listFilesFolder.findIndex(
      (item) => item.type === 'folder' && item.name === folder
    );
    if (position !== -1) {
      this.listFilesFolder[position].files.push({
        name: folder,
        relativePath: droppedFile.relativePath,
        file: file,
        status: 1,
        token: this.generateToken(),
      });
    } else {
      this.listFilesFolder.push(
        new FolderListClass({
          type: 'folder',
          token: this.generateToken(),
          name: folder,
          realName: realName,
          oneValidFile: !!this.compress ? false : true,
          compress: [],
          files: [
            {
              name: folder,
              relativePath: droppedFile.relativePath,
              file: file,
              status: 1,
              token: this.generateToken(),
            },
          ],
        })
      );
    }
  }

  /**
   * Assemble the structure in case single files have been dragged.
   *
   * @param droppedFile
   * @param file
   */
  pushSingleFile(droppedFile: any, file: File) {
    this.listSingleFiles.push({
      relativePath: droppedFile ? droppedFile.relativePath : '',
      file: file,
      status: file.size > this.limitSize ? 1 : 0,
      token: this.generateToken(),
    });
  }

  upload() {
    this.showUploader = true;

    // folder

    this.listFilesFolder.forEach((item: IFolderList, keyFolder) => {
      // if (this.useLocalDb) this.dexieUploadService.addOneFolder(item);
      // if (this.useLocalDb) this.localForageService.addOneFolder(item);

      item.files.forEach((folderItem: IFolderItem, keyFolderItem) => {
        // if (folderItem.file.size > this.limitSize && folderItem.progress !== 100) {
        if (folderItem.progress !== 100) {
          this.pending++;

          const payload = {
            type: 'folder',
            folderToken: item.token,
            fileToken: folderItem.token,
          };

          this.uploadProcess(folderItem.file, folderItem.token, payload);
        }
      });
    });

    // single item

    this.listSingleFilesUI.forEach((item: IFileItem) => {
      // if (this.useLocalDb) this.dexieUploadService.addOneFile(item);
      // if (this.useLocalDb) this.localForageService.addOneFile(item);

      if (item.progress !== 100) {
        if (!this.uploadedProgressLog.includes(item.token)) {
          this.pending++;
        }

        const payload = {
          type: 'single file',
          folderToken: item.token,
        };

        this.uploadedProgressLog.push(item.token);
        this.uploadProcess(item.file, item.token, payload);
      }
    });

    this.stacked[1].value = this.pending;
    this.total = this.pending;
  }

  uploadProcess(file: File, token: string, payload: any) {
    this.awsS3UploadService
      .postCreateFileObject(file, this.payloadToDB)
      .then((resCreatedObject: any) => {
        const updatedFile = new File(
          [file],
          `${resCreatedObject.file_id}.${file.name.split('.').pop()}`,
          { type: file.type }
        );

        // AWS SDK Method.

        if (this.method === 'sdk' || !this.method) {
          if (this.accessKeyId && this.secretAccessKey) {
            this.awsS3UploadService
              .uploadFile(updatedFile, token, this.dataS3 as IS3Data, payload)
              .then((resUploadedFile: any) => {
                this.awsS3UploadService
                  .postStepFunction(resCreatedObject, resUploadedFile)
                  .then((resStepFunction: any) => {
                    console.log('file uploaded: ', resStepFunction);
                  });
              });
          } else {
            console.error(
              'AWS SDK Upload Method: Require accessKeyId and secretAccessKey data'
            );
          }
        }

        // Presigned method.

        if (this.method === 'presigned') {
          this.awsS3UploadService
            .uploadMultipartFile(
              updatedFile,
              token,
              this.dataS3 as IS3Data,
              payload
            )
            .then((resUploadedFile) => {
              this.awsS3UploadService
                .postStepFunction(resCreatedObject, resUploadedFile)
                .then((resStepFunction: any) => {
                  console.log('file uploaded: ', resStepFunction);
                });
            })
            .catch((_) => {});
        }
      });
  }

  isFileInFolder(droppedFile: any) {
    return droppedFile.fileEntry.name !== droppedFile.relativePath;
  }

  fileOver(event: any) {
    // console.log(event);
  }

  fileLeave(event: any) {
    // console.log(event);
  }

  setIsCompressing(value: boolean) {
    this.hasCompressed = true;
    setTimeout(() => {
      this.isCompressing = !!value;
    });
  }

  /**
   * Filter by type.
   *
   * @param file
   */
  async filterType(file: File) {
    const fileItem = new FileClass(file);
    // @ts-ignore
    return this.filterTypes.includes(await fileItem.classify());
  }

  generateToken() {
    return Math.random().toString(36).substr(2) + new Date().getTime();
  }

  onSelectedHandle(event: any) {
    this.selectedListView = event;
  }

  /**
   * Paginate show more option.
   *
   * @param array
   * @param pageSize
   * @param pageNumber
   */
  paginate(array: any, pageSize: any, pageNumber?: any) {
    this.page++;
    pageNumber = this.page;
    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
  }

  /**
   * Show more.
   */
  btnShowMore() {
    this.listSingleFilesPaginateUI = [
      ...this.listSingleFilesPaginateUI,
      ...this.paginate(this.listSingleFiles, this.showMoreLimit),
    ];
  }

  btnShowCompressedFiles() {
    const compressedFiles = this.listSingleFilesPaginateUI.filter(
      (item) => item.type === 'mng-compressed'
    );

    compressedFiles.forEach((item) => {
      const files = item.compressedFiles || [];
      files.forEach((fileCompressed) => {
        this.listSingleFilesCompressedUI.push({
          relativePath: item.relativePath,
          file: fileCompressed,
          status: 1,
          token: item.token,
        });
      });
    });
  }

  getReallyUploadedFiles() {
    let reallyUploadedFiles = [];

    // Get all files with status 1 from folders files attribute array
    let folderFiles: any[] = [];
    if (this.listFilesFolderUI.length) {
      folderFiles = this.listFilesFolderUI
        .map((folder) => folder.files)
        .map((fileItem) => fileItem.filter((item) => item.status === 1))
        .reduce((prev, current) => [...prev, ...current])
        .map((e) => e.file);
    }

    // Get all files with status 1 from single files attribute array
    let singleFiles: any[] = [];
    if (this.listSingleFilesUI.length) {
      singleFiles = this.listSingleFilesUI
        .filter((item) => item.status === 1)
        .map((e) => e.file);
    }

    let allFiles: any[] = [];
    this.listFilesFolderUI.forEach((folderFile) => {
      folderFile.files.forEach((singleFile) => {
        if (singleFile.type !== 'mng-compressed') {
          allFiles.push(singleFile.file.name);
        }
      });
    });

    this.listSingleFilesUI.forEach((singleFile) => {
      if (singleFile.type !== 'mng-compressed') {
        allFiles.push(singleFile.file.name);
      }
    });

    this.listFilesFolderUI.forEach((folderItem, i) => {
      // folderItem.files.forEach((compressItem, j) => {
      //   this.listFilesFolderUI[i].files[j].progress = 100;
      // });
      folderItem.compress.forEach((compressItem, j) => {
        this.listFilesFolderUI[i].compress[j].progress = 100;
      });
      this.listFilesFolderUI[i].progress = 100;
    });

    this.listFilesFolderUI.forEach((item, i) => {
      this.listFilesFolderUI[i].progress = 100;
    });

    // TODO: VCA: This remove all list of files uploaded
    // this.files = [];
    // this.listSingleFilesPaginateUI = [];

    this.uploaded.emit({
      files: [...folderFiles, ...singleFiles],
      allFiles: allFiles,
    });
  }

  /**
   * Add file option without drag and drop.
   *
   * @param event
   */
  async onSelectFile(event: any) {
    const files = event.target.files;
    this.files = [...this.files, files];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (await this.filterType(file)) {
        this.pushSingleFile('', file);
      }

      // finish for loop
      if (i === files.length - 1) {
        if (!this.listFilesFolder.length && !this.listSingleFiles.length) {
          this.files = [];
          this.acceptedFilesType = this.filterTypes;
          setTimeout(() => {
            this.acceptedFilesType = [];
          }, 5000);
        }

        if (!!this.compress) {
          this.refactorFilesToUpload();
        }
        this.listFilesFolderUI = this.listFilesFolder;
        this.listSingleFilesUI = this.listSingleFiles;

        this.listSingleFilesPaginateUI = this.showMoreLimit
          ? this.paginate(this.listSingleFilesUI, this.showMoreLimit)
          : this.listSingleFilesUI;

        this.upload();

        // this.dexieUploadService.addOneFile(this.listFilesFolderUI[0]);
      }
    }
  }

  btnCloseUploader() {
    this.showUploader = false;
  }
}
